var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommercecloudbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 908,
    height: 1200,
    viewBox: "0 0 908 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6604_105824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.586 1175.71L325 1174.33L18.375 430.301L582.398 24.295L582.983 25.671L889.609 769.699L325.586 1175.71ZM21.6287 431.548L326.529 1171.41L886.355 768.452L581.454 28.595L21.6287 431.548Z",
    fill: "url(#paint0_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.674 1168.91L23.5234 791.199L24.044 789.78L309.325 31.089L884.475 408.844L883.955 410.263L598.674 1168.95V1168.91ZM26.712 789.78L597.567 1164.7L881.254 410.263L310.399 35.303L26.712 789.78Z",
    fill: "url(#paint1_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.353 1082.95L184.19 1081.41L88.5977 243.638L723.68 117.089L723.876 118.637L819.468 956.362L184.386 1082.91L184.353 1082.95ZM91.2982 246.304L186.338 1079.34L816.67 953.739L721.63 120.701L91.2982 246.304Z",
    fill: "url(#paint2_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.693 1200L441.88 1198.84L0 585.057L465.306 0L466.12 1.161L908 614.942L442.693 1200ZM3.38381 585.186L442.791 1195.53L904.616 614.813L465.209 4.472L3.38381 585.186Z",
    fill: "url(#paint3_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.161 1100.07L75.6094 931.938L202.828 99.9319L832.346 268.062L705.128 1100.03L705.161 1100.07ZM78.4401 929.444L703.274 1096.33L829.548 270.556L204.715 103.673L78.4401 929.444Z",
    fill: "url(#paint4_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.119 1158.72L287.631 1157.26L31.2422 380.765L619.895 41.2798L620.383 42.7418L876.772 819.235L288.119 1158.72ZM34.3982 382.399L289.355 1154.55L873.616 817.601L618.659 45.4508L34.3982 382.399Z",
    fill: "url(#paint5_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.606 1183.44L559.597 1182.63L12.5586 740.889L347.393 16.5979L348.402 17.4149L895.44 459.154L560.573 1183.44H560.606ZM15.8448 739.814L559.825 1179.06L892.187 460.143L348.207 20.9409L15.8448 739.814Z",
    fill: "url(#paint6_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.537 1050.06L113.484 202.917L754.489 149.984L794.541 997.126L153.537 1050.06ZM116.022 205.841L155.782 1046.66L792.003 994.116L752.244 153.295L116.022 205.841Z",
    fill: "url(#paint7_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.189 1196.43L402.44 1195.18L2.69531 532.855L3.63888 531.866L504.801 3.56885L505.549 4.81585L905.262 667.144L904.318 668.133L403.156 1196.39L403.189 1196.43ZM6.07912 533.328L403.579 1191.96L901.943 666.628L504.443 8.04084L6.07912 533.328Z",
    fill: "url(#paint8_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.232 1127.07L670.094 1126.64L55.1836 887.089L55.509 885.584L236.771 72.9277L237.909 73.3577L852.819 312.911L852.494 314.416L671.232 1127.07ZM58.1444 884.939L669.605 1123.16L849.859 315.061L238.397 76.8407L58.1444 884.939Z",
    fill: "url(#paint9_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.895 1137.48L251.505 1135.97L47.3047 332.906L48.4435 332.39L656.098 62.5221L656.488 64.0271L860.688 867.094L859.549 867.61L251.895 1137.48ZM50.3306 334.884L253.392 1133.48L857.662 865.116L654.601 66.5211L50.3306 334.884Z",
    fill: "url(#paint10_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.725 1193.46L4.94531 689.504L386.275 6.53601L903.054 510.539L521.692 1193.51L521.725 1193.46ZM8.29659 688.816L521.237 1189.04L899.735 511.141L386.795 10.965L8.29659 688.816Z",
    fill: "url(#paint11_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.057 1034.84L125.012 1013.72V1012.13L140.987 165.163L783.033 186.276V187.867L767.057 1034.84ZM127.452 1010.63L764.715 1031.57L780.56 189.372L143.297 168.431L127.452 1010.63Z",
    fill: "url(#paint12_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.05 1188.3L8.84766 481.126L543.945 11.6958L899.115 718.873L364.018 1188.26L364.05 1188.3ZM12.1664 481.986L364.701 1183.92L895.829 718.013L543.294 16.0818L12.1664 481.986Z",
    fill: "url(#paint13_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.634 1150.08L634.528 1149.52L37.7734 840.047L272.363 49.9229L273.469 50.4819L870.223 359.953L635.634 1150.08ZM40.8644 838.241L634.3 1145.99L867.165 361.716L273.729 54.0079L40.8644 838.241Z",
    fill: "url(#paint14_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.211 1112.15L216.918 1110.6L66.4688 287.068L690.782 87.8492L691.075 89.3972L841.557 912.933L217.244 1112.15H217.211ZM69.3645 289.39L219.001 1108.32L838.661 910.568L689.025 91.6762L69.3645 289.39Z",
    fill: "url(#paint15_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.325 1199.01L481.414 1197.98L0.75 637.431L1.53088 636.227L425.679 0.988892L426.59 2.02089L907.286 562.568L906.505 563.773L482.357 1199.05L482.325 1199.01ZM4.13381 637.13L482.13 1194.54L903.902 562.826L425.906 5.46089L4.13381 637.13Z",
    fill: "url(#paint16_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.191 1069.24L98.9844 974.25L99.1145 972.659L170.825 130.763L809.031 225.75L808.901 227.341L737.158 1069.24H737.191ZM101.62 971.455L735.076 1065.71L806.396 228.545L172.94 134.289L101.62 971.455Z",
    fill: "url(#paint17_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.586 1175.71L325 1174.33L18.375 430.301L582.398 24.295L582.983 25.671L889.609 769.699L325.586 1175.71ZM21.6287 431.548L326.529 1171.41L886.355 768.452L581.454 28.595L21.6287 431.548Z",
    fill: "url(#paint18_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.674 1168.91L23.5234 791.199L24.044 789.78L309.325 31.089L884.475 408.844L883.955 410.263L598.674 1168.95V1168.91ZM26.712 789.78L597.567 1164.7L881.254 410.263L310.399 35.303L26.712 789.78Z",
    fill: "url(#paint19_linear_6604_105824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.353 1082.95L184.19 1081.41L88.5977 243.638L723.68 117.089L723.876 118.637L819.468 956.362L184.386 1082.91L184.353 1082.95ZM91.2982 246.304L186.338 1079.34L816.67 953.739L721.63 120.701L91.2982 246.304Z",
    fill: "url(#paint20_linear_6604_105824)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6604_105824",
    x1: 18.375,
    y1: 600.022,
    x2: 889.609,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6604_105824",
    x1: 23.5234,
    y1: 600.022,
    x2: 884.475,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6604_105824",
    x1: 88.5977,
    y1: 600.021,
    x2: 819.436,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6604_105824",
    x1: 0,
    y1: 0,
    x2: 908,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6604_105824",
    x1: 75.6094,
    y1: 600.021,
    x2: 832.379,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6604_105824",
    x1: 31.2422,
    y1: 600.021,
    x2: 876.772,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6604_105824",
    x1: 12.5586,
    y1: 600.021,
    x2: 895.473,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6604_105824",
    x1: 113.484,
    y1: 600.021,
    x2: 794.541,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6604_105824",
    x1: 2.69531,
    y1: 600.021,
    x2: 905.294,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6604_105824",
    x1: 55.1836,
    y1: 600.021,
    x2: 852.819,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6604_105824",
    x1: 47.3047,
    y1: 600.022,
    x2: 860.688,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6604_105824",
    x1: 4.94531,
    y1: 600.022,
    x2: 903.054,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6604_105824",
    x1: 124.979,
    y1: 600.022,
    x2: 783.033,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6604_105824",
    x1: 8.84766,
    y1: 600.021,
    x2: 899.148,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6604_105824",
    x1: 37.7734,
    y1: 600.021,
    x2: 870.223,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6604_105824",
    x1: 66.4688,
    y1: 600.022,
    x2: 841.524,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6604_105824",
    x1: 0.75,
    y1: 600.021,
    x2: 907.253,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6604_105824",
    x1: 98.9518,
    y1: 600.022,
    x2: 809.064,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6604_105824",
    x1: 18.375,
    y1: 600.022,
    x2: 889.609,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6604_105824",
    x1: 23.5234,
    y1: 600.022,
    x2: 884.475,
    y2: 600.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6604_105824",
    x1: 88.5977,
    y1: 600.021,
    x2: 819.436,
    y2: 600.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6604_105824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 908,
    height: 1200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercecloudbg);
export default __webpack_public_path__ + "static/media/commercecloudbg.a16ac0369dd2835f9c5b3d84df7281b6.svg";
export { ForwardRef as ReactComponent };